import React from 'react';
import SMConst from 'lib/SMConst';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMReservationEditViewNote from 'components/dashboard/shared/SMReservationEditViewNote';
import SMReservationEditViewTel from 'components/dashboard/shared/SMReservationEditViewTel';
import SMOReservationEditViewChannelType from 'components/dashboard/owners/reservations/SMOReservationEditViewChannelType';
import SMReservationEditViewName from 'components/dashboard/shared/SMReservationEditViewName';
import SMReservationEditViewCorpName from 'components/dashboard/shared/SMReservationEditViewCorpName';
import SMReservationEditViewEmail from 'components/dashboard/shared/SMReservationEditViewEmail';
import SMReservationEditViewPlans from 'components/dashboard/shared/SMReservationEditViewPlans';
import SMReservationEditViewCapacity from 'components/dashboard/shared/SMReservationEditViewCapacity';
import SMReservationEditViewOptions from 'components/dashboard/shared/SMReservationEditViewOptions';
import SMReservationEditViewStatus from 'components/dashboard/shared/SMReservationEditViewStatus';
import SMReservationEditViewPrice from 'components/dashboard/shared/SMReservationEditViewPrice';
import SMReservationEditViewEventType from 'components/dashboard/shared/SMReservationEditViewEventType';
import SMReservationEditViewUseType from 'components/dashboard/shared/SMReservationEditViewUseType';
import SMReservationEditViewRentalSchedule from 'components/dashboard/shared/SMReservationEditViewRentalSchedule';
import SMRoomResource from 'resources/SMRoomResource';
import SMReservationEditViewPaymentPeriod from 'components/dashboard/shared/SMReservationEditViewPaymentPeriod';
import SMReservationEditViewStaySchedule from 'components/dashboard/shared/SMReservationEditViewStaySchedule';
import SMReservationEditViewCheckinTime from 'components/dashboard/shared/SMReservationEditViewCheckinTime';
import SMReservationEditViewNumberOfGuest from 'components/dashboard/shared/SMReservationEditViewNumberOfGuest';
import SMSpaceResource from 'resources/SMSpaceResource';

class SMReservationEditView extends React.Component {
  /* このクラスはSMOReservationEditView, SMUReservationEditViewの親クラスです */
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    var self = this;
    $(".js-datepicker").datepicker({
      dateFormat: "yy/mm/dd",
      minDate: 0,
      onClose (date, inst) {
        if ($(this)[0].name == 'billing_period') {
          self.changeBillingPeriod($(this)[0].name, date, true);
        } else {
          if (self.isStayReservation()) {
            self.changeStaySchedule($(this)[0].name, date, true);
          } else {
            if (self.isSessionPrice()) {
              self.changeSessionSchedule($(this)[0].name, date, true);
            } else {
              if (self.isReservationHourly()) {
                self.changeHourlySchedule($(this)[0].name, date, true);
              } else {
                self.changeSchedule($(this)[0].name, date, true);
              }
            }
          }
        }
      },
    });
  }

  uniqueErrorMessage(errors) {
    var unique = [];
    for (var i = 0; i < errors.length; i++) {
      var field = errors[i]['field'];
      var message = errors[i]['message'];
      var dupulicateFlag = false;
      for (var j = 0; j < unique.length; j++) {
        var tmp_f = unique[j]['field'];
        var tmp_m = unique[j]['message'];

        if (tmp_f === field && tmp_m === message) {
          dupulicateFlag = true;
          break;
        }
      }
      if (!dupulicateFlag) {
        unique.push(errors[i]);
      }
    }
    return unique;
  }

  radioButtonDidChangeValue(e) {
    if (this.props.delegate && typeof this.props.delegate.radioButtonDidChangeValue == 'function') {
      this.props.delegate.radioButtonDidChangeValue(e);
    }
  }

  // 更新対象以外のパラメータを設定
  setOtherFormData(names, formData, changePoint) {
    if (names.indexOf('billing[id]') == -1) {
      if (this.state.reservation.billing && this.state.reservation.billing.id) {
        formData.append('billing[id]', this.state.reservation.billing.id);
      } else {
        formData.append('billing[id]', "");
      }
    }

    if (names.indexOf('space_id') == -1) formData.append('space_id', this.state.spaceId);

    if (names.indexOf('room_id') == -1) formData.append('room_id', this.state.roomId);

    if (names.indexOf('plan_id') == -1) formData.append('plan_id', this.state.reservation.plan_id);

    if (names.indexOf('note') == -1) formData.append('note', this.state.reservation.note != null ? this.state.reservation.note : "");

    if (this.canDisplayNumberOfGuests()) {
      if (names.indexOf('number_of_guests') == -1) formData.append('number_of_guests', this.state.reservation.number_of_guests);
    } else {
      if (names.indexOf('capacity') == -1) formData.append('capacity', this.state.reservation.capacity);
    }


    if (names.indexOf('is_hourly') == -1) formData.append('is_hourly', this.state.reservation.is_hourly);

    if (names.indexOf('is_daily') == -1) formData.append('is_daily', this.state.reservation.is_daily);

    if (names.indexOf('is_changed_price') == -1) formData.append('is_changed_price', this.state.isChangedPrice ? "1" : "0");

    if (names.indexOf('billing[total_changed_amount]') == -1) {
      if (this.state.reservation.billing && this.state.reservation.billing.total_changed_amount != undefined && this.state.isChangedPrice) {
        formData.append('billing[total_changed_amount]', this.state.reservation.billing.total_changed_amount);
      }
    }

    if (changePoint != 'option_item') {
      var reservedOptions = this.state.reservation.reserved_option_items;
      var roomOptionIds = this.state.room.option_items.map(function(e) {
        return (e.id);
      });
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_item_id) == -1) continue;
          formData.append('reserved_option_items[][option_item_id]', reservedOptions[i].option_item_id);
          if (reservedOptions[i].countable) formData.append('reserved_option_items[][number]', reservedOptions[i].number);
        }
      }
    }

    if (changePoint != 'option_food') {
      var reservedOptions = this.state.reservation.reserved_option_foods;
      var roomOptionIds = this.state.room.option_foods.map(function(e) {
        return (e.id);
      });
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_food_id) == -1) continue;
          formData.append('reserved_option_foods[][option_food_id]', reservedOptions[i].option_food_id);
          if (reservedOptions[i].countable) formData.append('reserved_option_foods[][number]', reservedOptions[i].number);
        }
      }
    }

    if (names.indexOf('billing[change_description]') == -1 && this.state.reservation.billing != null) {
      if (this.state.reservation.billing.change_description == undefined) {
        formData.append('billing[change_description]', "");
      } else {
        formData.append('billing[change_description]', this.state.reservation.billing.change_description);
      }
    }

    if (names.indexOf('billing[period]') == -1 && this.state.reservation.billing != null) {
      if (this.state.reservation.billing.period) {
        formData.append('billing[period]', this.state.reservation.billing.period);
      }
    }

    if (names.indexOf('billing[period_description]') == -1 && this.state.reservation.billing != null) {
      if (this.state.reservation.billing.period_description) {
        formData.append('billing[period_description]', this.state.reservation.billing.period_description);
      }
    }

    if ((names.indexOf('reserved_schedules[][started_at]') == -1 ||
      names.indexOf('reserved_schedules[][duration]') == -1 ||
      names.indexOf('reserved_schedules[][is_stay_start]') == -1) && this.isStayReservation()) {
      var stayCheckinAt = this.state.stayCheckinAt;
      var stayCheckoutAt = this.state.stayCheckoutAt;
      var utc_offset = this.state.room ? this.state.room.space.utc_offset : 32400;

      if (stayCheckinAt && stayCheckoutAt) {
        var stayCheckinAtTime = stayCheckinAt.getTime();
        var stayCheckoutAtTime = stayCheckoutAt.getTime();
        var duration = (stayCheckoutAtTime - stayCheckinAtTime) / (60 * 1000);

        var changedStayCheckinAt = new Date(stayCheckinAt.getTime() + utc_offset * 1000);

        // 宿泊開始情報を設定
        formData.append('reserved_schedules[][started_at]', changedStayCheckinAt.toISOString());
        formData.append('reserved_schedules[][duration]', duration);
        formData.append('reserved_schedules[][is_stay_start]', true);
      }
    }

    if ((names.indexOf('reserved_schedules[][started_at]') == -1 ||
      names.indexOf('reserved_schedules[][duration]') == -1) && !this.isStayReservation()) {

      var data = this.generateReservedSchedule(this.state.plan, this.isReservationHourly(), this.state.startedDate, this.state.endedDate, this.state.startedHour, this.state.endedHour);

      for (var i = 0; i < data.length; i++) {
        formData.append(data[i][0], data[i][1]);
      }
    }

    if (names.indexOf('reserved_user[family_name]') == -1) {
      if (this.state.reservation.user && this.state.reservation.user.family_name != undefined) {
        formData.append(
          'reserved_user[family_name]', this.state.reservation.user.family_name
        );
      } else {
        formData.append(
          'reserved_user[family_name]', ''
        );
      }
    }

    if (names.indexOf('reserved_user[given_name]') == -1) {
      if (this.state.reservation.user && this.state.reservation.user.given_name != undefined) {
        formData.append(
          'reserved_user[given_name]', this.state.reservation.user.given_name
        );
      } else {
        formData.append(
          'reserved_user[given_name]', ''
        );
      }
    }

    if (names.indexOf('status') == -1) {
      formData.append('status', this.state.reservation.status);
    }

    formData.append('mediator', this.props.mediator);
    formData.append('method', this.state.reservation.method);

    if (this.state.reservation.user && this.state.reservation.user.tel) {
      formData.append('reserved_user[tel]', this.state.reservation.user.tel);
    }

    if (this.state.reservation.user && this.state.reservation.user.corp_name) {
      formData.append('reserved_user[corp_name]', this.state.reservation.user.corp_name);
    }

    if (this.state.reservation.user && this.state.reservation.user.email) {
      formData.append('reserved_user[email]', this.state.reservation.user.email);
    }

    if (this.state.reservation.channel_type) {
      formData.append('channel_type', this.state.reservation.channel_type);
    }

    if (this.state.reservation.event_type) {
      formData.append('event_type', this.state.reservation.event_type);
    }

    if (this.state.reservation.use_type) {
      formData.append('use_type', this.state.reservation.use_type);
    }
  }

  isSessionPrice() {
    return !!this.state.plan.has_session_price;
  }

  isReservationHourly() {
    return !!(this.state.reservation.is_hourly ||
    (this.state.plan && this.state.plan.has_session_price && this.state.plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour));
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  canSubmitButton() {
    if (this.state.spaceId && this.state.roomId && this.state.saveButtonStatus) {
      return true;
    } else {
      return false;
    }
  }

  // 各項目ごとに更新をかける
  changePlan(value) {
    var reservation = this.state.reservation;

    var plan = this.state.room;
    if (value != 0) {
      for (var i = 0; this.state.room.plans.length > i; i++) {
        if (value == this.state.room.plans[i].id) {
          plan = this.state.room.plans[i];
          break;
        }
      }
    }

    this.setState({
      plan: plan
    });

    var updateData = [];
    updateData.push(['plan_id', value]);

    if (!this.isStayReservation()) {
      updateData = updateData.concat(this.generateReservedSchedule(plan, this.isReservationHourly(), this.state.startedDate, this.state.endedDate, this.state.startedHour, this.state.endedHour));
    }

    // API問い合わせ
    this.updateResource(updateData, true);
  }

  generateReservedSchedule(plan, isHourly, startedDate, endedDate, startedHour, endedHour) {
    var reservedSchedules = [];
    var utc_offset = this.state.room ? this.state.room.space.utc_offset : 32400;

    if (startedDate && endedDate) {
      if (plan.has_session_price) {
        var startedAt = new Date(startedDate);
        startedAt.setHours(startedHour);
        var endedAt = new Date(endedDate);
        endedAt.setHours(endedHour);

        var duration = 0;
        var sessionDuration = 0;
        if (plan.min_required_session_hour_unit == 0) {
          sessionDuration = plan.min_required_session_hour;
          duration = 60;
        } else {
          sessionDuration = plan.min_required_session_hour * 24;
          duration = 1440;
        }
        var tmpTime = startedAt;
        if (isHourly) {
          while (tmpTime.getTime() < endedAt.getTime()) {
            var changedStartedAt = new Date(tmpTime.getTime() + utc_offset * 1000);

            reservedSchedules.push(['reserved_schedules[][started_at]', changedStartedAt.toISOString()]);
            reservedSchedules.push(['reserved_schedules[][duration]', duration]);

            if (plan.has_session_price && ((tmpTime.getTime() - startedAt.getTime()) / (60 * 60 * 1000)) % sessionDuration == 0) {
              reservedSchedules.push(['reserved_schedules[][is_session_start]', true]);
            }

            tmpTime = new Date(tmpTime.getTime() + duration * (60 * 1000));
          }
        } else {
          while (tmpTime.getTime() < endedAt.getTime()) {
            var changedStartedAt = new Date(tmpTime.getTime() + utc_offset * 1000);

            reservedSchedules.push(['reserved_schedules[][started_at]', changedStartedAt.toISOString()]);
            reservedSchedules.push(['reserved_schedules[][duration]', duration]);

            if (plan.has_session_price && ((tmpTime.getTime() - startedAt.getTime()) / (60 * 60 * 1000)) % sessionDuration == 0) {
              reservedSchedules.push(['reserved_schedules[][is_session_start]', true]);
            }

            tmpTime = new Date(tmpTime.getTime() + duration * (60 * 1000));
          }
        }
      } else {
        if (isHourly) {
          var startedAt = new Date(startedDate);
          startedAt.setHours(startedHour);
          var endedAt = new Date(endedDate);
          endedAt.setHours(endedHour);

          var duration = 60;
          var tmpTime = startedAt;
          while (tmpTime.getTime() < endedAt.getTime()) {
            var changedStartedAt = new Date(tmpTime.getTime() + utc_offset * 1000);

            reservedSchedules.push(['reserved_schedules[][started_at]', changedStartedAt.toISOString()]);
            reservedSchedules.push(['reserved_schedules[][duration]', duration]);

            tmpTime = new Date(tmpTime.getTime() + duration * (60 * 1000));
          }
        } else {
          var startedAt = new Date(startedDate);
          var endedAt = new Date(endedDate);

          var duration = 1440;
          var tmpTime = startedAt;
          while (tmpTime.getTime() < endedAt.getTime()) {
            var changedStartedAt = new Date(tmpTime.getTime() + utc_offset * 1000);

            reservedSchedules.push(['reserved_schedules[][started_at]', changedStartedAt.toISOString()]);
            reservedSchedules.push(['reserved_schedules[][duration]', duration]);

            tmpTime = new Date(tmpTime.getTime() + duration * (60 * 1000));
          }
        }
      }
    }

    return reservedSchedules;
  }

  formatReservationPrice() {
    if (this.state.reservation.billing && this.state.reservation.billing.total_amount_with_last_minute_discount_except_tax_text != null) {
      return this.state.reservation.billing.total_amount_with_last_minute_discount_except_tax_text;
    } else {
      return '￥ -';
    }
  }

  isStayReservation() {
    return this.state.plan && this.state.plan.rent_type == SMConst.RentType.Stay ? true : false;
  }

  canDisplayNumberOfGuests() {
    if (this.state.plan && (this.state.plan.price_calc_type == SMConst.PriceCalcType.PerPerson || this.state.plan.rent_type == SMConst.RentType.Stay)) {
      return true;
    }
    return false;
  }

  beginningOfDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  }

  renderSelectSpace() {
    return <td>会場・スペース名を選択して下さい。</td>;
  }

  // Room情報をAPIに問い合わせ
  getRoomResource(value) {
    SMRoomResource.getRoom(value, function(room, error, xhr) {
      this.setState({
        room: room,
        roomId: value,
        plan: room,
      });

      setTimeout(function() {
        $(this.refs.reservationTable).stopLoading();
      }.bind(this), 300);
    }.bind(this));

    var reservation = this.state.reservation;
    if (reservation.billing != null) reservation.billing.total_amount_text = null;
    if (!reservation.plan_id) reservation.plan_id = 0;
    if (this.canDisplayNumberOfGuests() && !reservation.number_of_guests) reservation.number_of_guests = 1;
    if (!this.canDisplayNumberOfGuests() && !reservation.capacity) reservation.capacity = 1;

    this.setState({
      reservation: reservation
    });

    $(this.refs.reservationTable).startLoading();
  }

  // Room情報が変わった場合に動作
  changeRoom(value) {
    this.getRoomResource(value);
  }

  getSpaceResource(value) {
    SMSpaceResource.getSpace(value, function(data, error, xhr) {
      this.setState({
        spaceId: value,
        space: data,
        roomId: "",
        room: null,
        plan: null,
      });

      setTimeout(function() {
        $(this.refs.reservationTable).stopLoading();
      }.bind(this), 300);
    }.bind(this));

    $(this.refs.reservationTable).startLoading();
  }

  changeSpace(value) {
    this.getSpaceResource(value);
  }

  renderPlans() {
    var tableData;
    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {

      tableData =
        <SMReservationEditViewPlans
          reservation={this.state.reservation}
          room={this.state.room}
          plan={this.state.plan}
          plans={this.state.room.plans}
          delegate={this} />;
    }
    return (
      <tr>
        <th>プラン<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>
    );
  }

  renderSchedules() {
    var tableData;

    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewRentalSchedule
          reservation={this.state.reservation}
          room={this.state.room}
          startedDate={this.state.startedDate}
          startedHour={this.state.startedHour}
          endedDate={this.state.endedDate}
          endedHour={this.state.endedHour}
          plan={this.state.plan}
          method={this.props.method}
          errors={this.state.errors}
          delegate={this} />;
    }

    return (
      <tr>
        <th>日時<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>
    );
  }

  changeSchedule(name, value, dryrun) {
    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;


    var updateData = [];
    if (name == 'started_date') {
      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      startedDate = new Date(year, month, day, 0, 0);
    } else {
      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      endedDate = new Date(year, month, day, 0, 0);
      if (this.isUpdateEndedDateRequirement()) endedDate.setDate(endedDate.getDate() + 1);
    }

    this.setState({
      startedDate: startedDate,
      endedDate: endedDate,
    });

    if (!startedDate) {
      this.setState({
        errors: [{ resource: 'Reservation', field: 'schedules', message: '開始日を入力して下さい。' }]
      });
      return;
    } else {
      this.setState({
        errors: []
      });
    }

    if (!endedDate) {
      this.setState({
        errors: [{ resource: 'Reservation', field: 'schedules', message: '終了日を入力して下さい。' }]
      });
      return;
    } else {
      this.setState({
        errors: []
      });
    }

    updateData = updateData.concat(this.generateReservedSchedule(this.state.plan, false, startedDate, endedDate, this.state.startedHour, this.state.endedHour));

    this.updateResource(updateData, true);
  }

  isUpdateEndedDateRequirement() {
    return !this.state.reservation.is_hourly
      && !(this.state.plan && this.state.plan.has_session_price
      && this.state.plan.min_required_session_hour_unit == 0);
  }

  changeSessionSchedule(name, value, dryrun) {
    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;


    var updateData = [];
    var duration = 1440;
    if (name == 'started_date') {
      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      startedDate = new Date(year, month, day, 0, 0);
    } else {
      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      endedDate = new Date(year, month, day, 0, 0);
    }

    this.setState({
      startedDate: startedDate,
      endedDate: endedDate,
    });

    if (!startedDate) {
      this.setState({
        errors: [{ resource: 'Reservation', field: 'schedules', message: '開始日を入力して下さい。' }]
      });
      return;
    } else {
      this.setState({
        errors: []
      });
    }

    if (!endedDate) {
      this.setState({
        errors: [{ resource: 'Reservation', field: 'schedules', message: '終了日を入力して下さい。' }]
      });
      return;
    } else {
      this.setState({
        errors: []
      });
    }

    updateData = updateData.concat(this.generateReservedSchedule(this.state.plan, false, startedDate, endedDate, this.state.startedHour, this.state.endedHour));

    this.updateResource(updateData, true);
  }

  changeHourlySchedule(name, value, dryrun) {
    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;
    var year = parseInt(value.split('/')[0]);
    var month = parseInt(value.split('/')[1]) - 1;
    var day = parseInt(value.split('/')[2]);
    var hour = null;

    if (startedDate && endedDate) {
      var startedAt = new Date(startedDate);
      startedAt.setHours(this.state.startedHour);
      var endedAt = new Date(endedDate);
      endedAt.setHours(this.state.endedHour);

      if (name == 'started_date') {
        hour = this.state.startedHour;
        startedAt = new Date(year, month, day, hour, 0);
        startedDate = this.beginningOfDate(startedAt);
      } else {
        hour = this.state.endedHour;
        endedAt = new Date(year, month, day, hour, 0);
        endedDate = this.beginningOfDate(endedAt);
      }

      var updateData = this.generateReservedSchedule(this.state.plan, true, startedDate, endedDate, this.state.startedHour, this.state.endedHour);

      this.setState({
        startedDate: startedDate,
        endedDate: endedDate,
      });

      this.updateResource(updateData, true);
    } else {
      if (name == 'started_date') {
        hour = this.state.startedHour;
        startedDate = new Date(year, month, day, hour, 0);
      } else {
        hour = this.state.endedHour;
        endedDate = new Date(year, month, day, hour, 0);
      }

      this.setState({
        startedDate: startedDate,
        endedDate: endedDate,
      });
    }
  }

  changeScheduleHourButtonAtSession(name, value) {
    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;

    // 開始時刻、終了時刻を取得
    var startedHour = this.state.startedHour;
    var endedHour = this.state.endedHour;

    var hour = parseInt(value.split(":")[0]);

    if (startedDate && endedDate) {
      // 開始日、終了日を取得
      var startedAt = new Date(startedDate);
      startedAt.setHours(this.state.startedHour);
      var endedAt = new Date(endedDate);
      endedAt.setHours(this.state.endedHour);

      if (name == 'started_hour') {
        startedAt.setHours(hour);
        startedHour = hour;
      } else {
        endedAt.setHours(hour);
        endedHour = hour;
      }

      var updateData = this.generateReservedSchedule(this.state.plan, true, startedDate, endedDate, startedHour, endedHour);

      this.setState({
        startedHour: startedHour,
        endedHour: endedHour,
      });

      this.updateResource(updateData, true);
    } else {

      if (name == 'started_hour') {
        startedHour = hour;
      } else {
        endedHour = hour;
      }

      this.setState({
        startedHour: startedHour,
        endedHour: endedHour,
      });
    }
  }

  changeScheduleHourButton(name, value) {
    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;

    // 開始時刻、終了時刻を取得
    var startedHour = this.state.startedHour;
    var endedHour = this.state.endedHour;

    var hour = parseInt(value.split(":")[0]);

    if (startedDate && endedDate) {
      // 開始日、終了日を取得
      var startedAt = new Date(startedDate);
      startedAt.setHours(this.state.startedHour);
      var endedAt = new Date(endedDate);
      endedAt.setHours(this.state.endedHour);

      if (name == 'started_hour') {
        startedAt.setHours(hour);
        startedHour = hour;
      } else {
        endedAt.setHours(hour);
        endedHour = hour;
      }

      var updateData = this.generateReservedSchedule(this.state.plan, true, startedDate, endedDate, startedHour, endedHour);

      this.setState({
        startedHour: startedHour,
        endedHour: endedHour,
      });

      this.updateResource(updateData, true);
    } else {

      if (name == 'started_hour') {
        startedHour = hour;
      } else {
        endedHour = hour;
      }

      this.setState({
        startedHour: startedHour,
        endedHour: endedHour,
      });
    }

  }

  changeDailyButton(checked) {
    var reservation = this.state.reservation;
    reservation.is_hourly = !checked;
    reservation.is_daily = checked;

    this.setState({
      reservation: reservation
    });
  }

  // 終日時刻、時間時刻切り替えラジオボタン
  changeHourlyDailyButton(name, value) {
    var updateData = [];
    var isHourly = value == 1;

    updateData.push(['is_hourly', isHourly]);

    var startedDate = this.state.startedDate;
    var endedDate = this.state.endedDate;

    var startedHour = this.state.startedHour;
    var endedHour = this.state.endedHour;

    if (this.props.method != SMConst.ReservationMethod.Inquiry) {
      // 時 -> 日
      if (this.isReservationHourly() && !isHourly) {
        endedDate.setDate(endedDate.getDate() + 1);
      }

      // 日 -> 時
      if (!this.isReservationHourly() && isHourly) {
        endedDate.setDate(endedDate.getDate() - 1);
      }
    }

    updateData = updateData.concat(this.generateReservedSchedule(this.state.plan, isHourly, startedDate, endedDate, startedHour, endedHour));

    var reservation = this.state.reservation;
    reservation.is_hourly = isHourly;

    this.setState({
      reservation: reservation,
      startedDate: startedDate,
      startedHour: startedHour,
      endedDate: endedDate,
      endedHour: endedHour,
    });


    this.updateResource(updateData, true);
  }

  // 宿泊日項目表示
  renderStaySchedules() {
    var tableData;

    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewStaySchedule
          stayCheckinAt={this.state.stayCheckinAt}
          reservation={this.state.reservation}
          stayCheckoutAt={this.state.stayCheckoutAt}
          errors={this.state.errors}
          delegate={this} />;
    }

    return (
      <tr>
        <th>宿泊<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>
    );
  }

  changeStaySchedule(name, value, dryrun) {

    var stayCheckinAt = this.state.stayCheckinAt;
    var stayCheckoutAt = this.state.stayCheckoutAt;

    var changedNewStayCheckinAtToUTC;
    var duration;

    var room = this.state.room;

    var utc_offset = this.state.room ? this.state.room.space.utc_offset : 32400;

    if (name == 'stay_checkin_at') {
      var hour = stayCheckinAt ? stayCheckinAt.getHours() : room.stay_checkin_start_hour;
      var minute = stayCheckinAt ? stayCheckinAt.getMinutes() : 0;

      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      var newStayCheckinAt = new Date(year, month, day, hour, minute);

      // チェックアウト日が入力されていない場合へエラー表示
      if (!stayCheckoutAt) {
        this.setState({
          stayCheckinAt: newStayCheckinAt,
          errors: [{ resource: 'Reservation', field: 'schedules', message: '開始日を入力して下さい。' }]
        });
        return;
      }

      this.setState({
        stayCheckinAt: newStayCheckinAt,
      });

      duration = (stayCheckoutAt.getTime() - newStayCheckinAt.getTime()) / (60 * 1000);
      changedNewStayCheckinAtToUTC = new Date(newStayCheckinAt.getTime() + utc_offset * 1000);
    } else {
      var hour = stayCheckoutAt ? stayCheckoutAt.getHours() : room.stay_checkout_hour;
      var minute = stayCheckoutAt ? stayCheckoutAt.getMinutes() : 0;

      var year = parseInt(value.split('/')[0]);
      var month = parseInt(value.split('/')[1]) - 1;
      var day = parseInt(value.split('/')[2]);

      var newStayCheckoutAt = new Date(year, month, day, hour, minute);

      duration = (newStayCheckoutAt.getTime() - stayCheckinAt.getTime()) / (60 * 1000);
      changedNewStayCheckinAtToUTC = new Date(stayCheckinAt.getTime() + utc_offset * 1000);

      this.setState({
        stayCheckoutAt: newStayCheckoutAt,
      });
    }

    // API問い合わせ
    this.updateResource([
      ['reserved_schedules[][started_at]', changedNewStayCheckinAtToUTC.toISOString()],
      ['reserved_schedules[][duration]', duration],
      ['reserved_schedules[][is_stay_start]', true]
    ], true);

  }

  renderOptionFoods() {
    let tableData;
    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData = this.renderOptions('option_food',
        this.state.room.option_foods,
        this.state.reservation.reserved_option_foods ? this.state.reservation.reserved_option_foods : []);
    }

    let need_status;
    if (this.state.plan && this.state.plan.is_required_food) {
      need_status = <span className="icon-form icon-form__required dashboard-form-table__icon">必須</span>;
    } else {
      need_status = <span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span>;
    }

    return (
      <tr>
        <th>飲食{need_status}</th>
        {tableData}
      </tr>
    );
  }

  renderOptionItems() {
    var tableData;
    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData = this.renderOptions(
        'option_item',
        this.state.room.option_items,
        this.state.reservation.reserved_option_items ? this.state.reservation.reserved_option_items : []);
    }

    return (
      <tr>
        <th>オプション<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  renderOptions(name, roomOptions, reservedOptions) {
    return (
      <SMReservationEditViewOptions
        name={name}
        room_options={roomOptions}
        reservation={this.state.reservation}
        reserved_options={reservedOptions}
        errors={this.state.errors}
        delegate={this} />
    );
  }

  changeOptions(type, name, value, checked) {
    var updateData = [];
    var reservation = this.state.reservation;

    var reservedOptions = this.state.reservation.reserved_option_items;
    var roomOptionIds = this.state.room.option_items.map(function(e) {
      return (e.id);
    });

    if (type == 'option_item') {
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_item_id) == -1) continue;
          if (reservedOptions[i].option_item_id != value || checked) {
            updateData.push(['reserved_option_items[][option_item_id]', reservedOptions[i].option_item_id]);
            if (reservedOptions[i].countable) updateData.push(['reserved_option_items[][number]', reservedOptions[i].number]);
          }
        }
      }
    } else {
      reservedOptions = this.state.reservation.reserved_option_foods;
      roomOptionIds = this.state.room.option_foods.map(function(e) {
        return (e.id);
      });
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_food_id) == -1) continue;
          if (reservedOptions[i].option_food_id != value || checked) {
            updateData.push(['reserved_option_foods[][option_food_id]', reservedOptions[i].option_food_id]);
            if (reservedOptions[i].countable) updateData.push(['reserved_option_foods[][number]', reservedOptions[i].number]);
          }
        }
      }
    }

    if (checked) {
      updateData.push([name, value]);

      if (type == 'option_item') {
        var master_option_item = this.state.room.option_items.filter(function(e) {
          return (e.id == parseInt(value));
        })[0];

        var reserved_option_item = null;
        if (this.state.reservation.reserved_option_items) {
          reserved_option_item = this.state.reservation.reserved_option_items.filter(function(e) {
            return (e.option_item_id == parseInt(value));
          })[0];
        }

        if (master_option_item && master_option_item.countable) updateData.push(['reserved_option_items[][number]', (reserved_option_item && reserved_option_item.number) || 1]);
      } else {
        var master_option_food = this.state.room.option_foods.filter(function(e) {
          return (e.id == parseInt(value));
        })[0];

        var reserved_option_food = null;
        if (this.state.reservation.reserved_option_foods) {
          reserved_option_food = this.state.reservation.reserved_option_foods.filter(function(e) {
            return (e.option_food_id == parseInt(value));
          })[0];
        }

        if (master_option_food && master_option_food.countable) updateData.push(['reserved_option_foods[][number]', (reserved_option_food && reserved_option_food.number) || 1]);
      }
    }

    this.setState({
      reservation: reservation
    });

    this.updateResource(updateData, true, type);
  }

  changeOptionsNumber(type, name, value, checked) {
    var updateData = [];
    var reservation = this.state.reservation;
    var roomOptionIds = this.state.room.option_items.map(function(e) {
      return (e.id);
    });

    if (type == 'option_item') {
      var reservedOptions = this.state.reservation.reserved_option_items;
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_item_id) == -1) continue;
          if (reservedOptions[i].option_item_id == name) {
            updateData.push(['reserved_option_items[][option_item_id]', reservedOptions[i].option_item_id]);
            updateData.push(['reserved_option_items[][number]', value]);
          } else {
            updateData.push(['reserved_option_items[][option_item_id]', reservedOptions[i].option_item_id]);
            if (reservedOptions[i].countable) updateData.push(['reserved_option_items[][number]', reservedOptions[i].number]);
          }
        }
      }

    } else {
      var reservedOptions = this.state.reservation.reserved_option_foods;
      roomOptionIds = this.state.room.option_foods.map(function(e) {
        return (e.id);
      });
      if (reservedOptions) {
        for (var i = 0; i < reservedOptions.length; i++) {
          if (roomOptionIds.indexOf(reservedOptions[i].option_food_id) == -1) continue;
          if (reservedOptions[i].option_food_id == name) {
            updateData.push(['reserved_option_foods[][option_food_id]', reservedOptions[i].option_food_id]);
            updateData.push(['reserved_option_foods[][number]', value]);
          } else {
            updateData.push(['reserved_option_foods[][option_food_id]', reservedOptions[i].option_food_id]);
            if (reservedOptions[i].countable) updateData.push(['reserved_option_foods[][number]', reservedOptions[i].number]);
          }
        }
      }
    }

    this.setState({
      reservation: reservation
    });

    this.updateResource(updateData, true, type);
  }

  // チェックインタイム
  renderCheckInTime() {
    var tableData;
    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewCheckinTime
          reservation={this.state.reservation}
          stayCheckinAt={this.state.stayCheckinAt}
          room={this.state.room}
          errors={this.state.errors}
          delegate={this} />;
    }
    return (
      <tr>
        <th>チェックイン時刻
          <span className="icon-form icon-form__required dashboard-form-table__icon">
            必須
          </span>
        </th>
        {tableData}
      </tr>

    );
  }

  changeCheckinTime(name, value) {
    var stayCheckinAt = this.state.stayCheckinAt;
    var newStayCheckinAt = new Date(
      stayCheckinAt.getFullYear(),
      stayCheckinAt.getMonth(),
      stayCheckinAt.getDate(),
      parseInt(value.split(':')[0]),
      parseInt(value.split(':')[1]), 0);
    var utc_offset = this.state.room ? this.state.room.space.utc_offset : 32400;
    var stayCheckoutAt = this.state.stayCheckoutAt;
    var duration = (stayCheckoutAt.getTime() - stayCheckinAt.getTime()) / (60 * 1000);
    var changedNewStayCheckinAtToUTC = new Date(newStayCheckinAt.getTime() + utc_offset * 1000);

    this.setState({
      stayCheckinAt: newStayCheckinAt,
    });

    this.updateResource([
      ['reserved_schedules[][started_at]', changedNewStayCheckinAtToUTC.toISOString()],
      ['reserved_schedules[][duration]', duration],
      ['reserved_schedules[][is_stay_start]', true]
    ], true);
  }

  // 人数
  renderHeadCount() {
    var tableData;

    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewNumberOfGuest
          reservation={this.state.reservation}
          room={this.state.room}
          rentType={this.state.plan.rent_type}
          delegate={this} />;
    }

    return (
      <tr>
        <th>人数<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>

    );
  }

  changeNumberOfGuests(value) {
    this.updateResource([
      ['number_of_guests', value]
    ], true);
  }

  renderPrice(isOwner) {
    var tableData;
    if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewPrice
          mediator={this.props.mediator}
          reservation={this.state.reservation}
          isChangedPrice={this.state.isChangedPrice}
          errors={this.state.errors}
          isOwner={isOwner}
          delegate={this} />;
    }

    return (
      <tr>
        <th>金額<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>
    );
  }

  changePriceManually(name, value, dryrun) {

    var valueIsChangedPrice = this.state.isChangedPrice ? "1" : "0";

    this.updateResource([
      ['is_changed_price', valueIsChangedPrice],
      ['billing[total_changed_amount]', value]
    ], dryrun);

    var reservation = this.state.reservation;
    reservation.billing.total_changed_amount = value;

    this.setState({
      reservation: reservation,
      isChangedPrice: valueIsChangedPrice
    });

  }

  changePriceDescription(name, value, dryrun) {
    var valueIsChangedPrice = this.state.isChangedPrice ? "1" : "0";

    this.updateResource([
      ['is_changed_price', valueIsChangedPrice],
      ['billing[change_description]', value]
    ], true);

    this.setState({
      isChangedPrice: valueIsChangedPrice
    });
  }

  changePriceRadioButton(name, value, dryrun) {
    this.updateResource([
      ['is_changed_price', value]
    ], true);

    var isChangedPrice = value == "1";
    this.setState({
      isChangedPrice: isChangedPrice
    });
  }

  renderStatus() {
    if (!SMReservationHelper.isOwnerDirect(this.props.mediator)) return null;

    var tableData;
    if (this.state.room) {
      tableData =
        <SMReservationEditViewStatus
          reservation={this.state.reservation}
          statuses={this.state.statuses}
          errors={this.state.errors}
          delegate={this}
        />;
    } else {
      tableData = this.renderSelectSpace();
    }

    return (
      <tr>
        <th>ステータス<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  changeStatus(name, value) {
    var reservation = this.state.reservation;
    reservation.status = value;
    this.setState({
      reservation: reservation,
    });
    this.updateResource([name, value], true);
  }

  renderEventType() {
    var tableData;

    if (!SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      return null;
    } else if (this.state.room) {
      tableData =
        <SMReservationEditViewEventType
          reservation={this.state.reservation}
          room={this.state.room}
          errors={this.state.errors}
          delegate={this} />;
    } else {
      tableData = this.renderSelectSpace();
    }

    return (
      <tr>
        <th>利用目的<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  changeEventType(name, value) {
    var reservation = this.state.reservation;
    reservation.event_type = value;

    this.setState({
      reservation: reservation
    });
  }

  renderUseType() {
    var tableData;

    if (!SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      return null;
    } else if (!this.state.room) {
      tableData = this.renderSelectSpace();
    } else {
      tableData =
        <SMReservationEditViewUseType
          useType={this.state.reservation.use_type}
          room={this.state.room}
          delegate={this} />;
    }

    return (
      <tr>
        <th>利用形態<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  changeUseType(name, value) {
    var reservation = this.state.reservation;
    reservation.use_type = value;

    this.setState({
      reservation: reservation
    });
  }

  renderCapacity() {
    var tableData;
    if (!SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      return null;
    } else if (this.state.room) {
      tableData =
        <SMReservationEditViewCapacity
          reservation={this.state.reservation}
          errors={this.state.errors}
          delegate={this} />;
    } else {
      tableData = this.renderSelectSpace();
    }

    return (
      <tr>
        <th>人数<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  renderName() {
    var tableData;

    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      tableData =
        <SMReservationEditViewName
          reservation={this.state.reservation}
          errors={this.state.errors}
          delegate={this}
        />;
    } else {
      if (this.state.reservation.user) {
        tableData =
          <td>
            <img src={this.state.reservation.user.profile_image} className="reserve-member__img"
                 alt={this.state.reservation.user.contact_name} />
            <p className="reserve-member__name">
              <a
                href={Routes.user_path(this.state.reservation.user.username)}>{this.state.reservation.user.contact_name}</a>
            </p>
          </td>;
      } else {
        tableData = <td></td>;
      }
    }

    return (
      <tr>
        <th>お名前<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        {tableData}
      </tr>
    );
  }

  changeName(name, value) {
    var reservation = this.state.reservation;

    if (reservation.user == undefined) {
      reservation.user = {};
    }

    if (name == 'reserved_user[family_name]') reservation.user.family_name = value;
    if (name == 'reserved_user[given_name]') reservation.user.given_name = value;

    this.setState({
      reservation: reservation
    });

    this.updateResource([
      [name, value]
    ], true);
  }

  renderCorpName() {
    var tableData;

    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      tableData =
        <SMReservationEditViewCorpName
          reservation={this.state.reservation}
          delegate={this}
        />;
    } else {
      if (this.state.reservation.user) {
        tableData =
          <td>{this.state.reservation.use_type == SMConst.ReservationUseType.Corporate ? this.state.reservation.user.corp_name : '-'}</td>;
      } else {
        tableData = <td></td>;
      }
    }

    return (
      <tr>
        <th>法人・団体名<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  changeCorpName(name, value) {
    var reservation = this.state.reservation;
    if (!reservation.user) {
      reservation.user = {};
    }

    reservation.user.corp_name = value;
  }

  renderTel() {
    var tableData;
    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      tableData =
        <SMReservationEditViewTel
          reservation={this.state.reservation}
          errors={this.state.errors}
          delegate={this} />;
    } else {
      if (!this.state.reservation.user) {
        tableData = <td></td>;
      } else if (this.state.reservation.status == SMConst.ReservationStatus.Paid) {
        if (this.state.user) {
          tableData = <td>{this.state.user.contact.attributes.tel}</td>;
        } else {
          tableData = <td>{this.state.reservation.user.contact.tel}</td>;
        }
      } else {
        tableData = <td>予約完了後に表示されます。</td>;
      }
    }

    return (
      <tr>
        <th>電話番号<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
        {tableData}
      </tr>
    );
  }

  changeTel(name, value) {
    var reservation = this.state.reservation;
    if (!reservation.user) {
      reservation.user = {};
    }

    reservation.user.tel = value;

    this.setState({
      reservation: reservation
    });
  }

  renderEmail() {
    var tableData;
    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      tableData =
        <SMReservationEditViewEmail
          reservation={this.state.reservation}
          delegate={this} />;

      return (
        <tr>
          <th>メールアドレス<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span></th>
          {tableData}
        </tr>
      );
    } else {
      return null;
    }
  }

  changeEmail(name, value) {
    var reservation = this.state.reservation;
    if (!reservation.user) {
      reservation.user = {};
    }

    reservation.user.email = value;

    this.setState({
      reservation: reservation
    });
  }

  renderGuestName() {
    if (parseInt(this.state.reservation.number_of_guests) == 0) return null;
    if (this.state.reservation.rent_type != SMConst.RentType.Stay) return null;
    if (this.state.room == null || this.state.room.stay_certification_type != SMConst.StayCertificationType.VacationRental) return null;
    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) return null;

    var guests = [];
    for (var i = 0; i < this.state.reservation.number_of_guests - 1; i++) {
      var guest = this.state.reservation.guest_companions[i];
      var guestNumber = i + 2;
      if (guest) {
        guests.push(
          <tr key={"guest-" + guestNumber}>
            <th>宿泊者{guestNumber}<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span>
            </th>
            <td>
              <img src={guest.profile_image} className="reserve-member__img" alt={guest.contact_name} />
              <p className="reserve-member__name"><a href={Routes.user_path(guest.username)}>{guest.name}</a></p>
            </td>
          </tr>
        );
      } else {
        guests.push(
          <tr key={"guest-" + guestNumber}>
            <th>宿泊者{guestNumber}<span className="icon-form icon-form__optional dashboard-form-table__icon">任意</span>
            </th>
            <td>
              <img src={SMFormatHelper.defaultIcon()} className="reserve-member__img" alt="未登録" />
              <p className="reserve-member__name">未登録</p>
            </td>
          </tr>
        );
      }
    }
    return guests;
  }

  renderPaymentPeriod(isOwner) {
    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) return null;
    if (this.props.method == SMConst.ReservationMethod.Inquiry) return null;

    return (
      <tr>
        <th>支払期限<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
        <SMReservationEditViewPaymentPeriod
          reservation={this.state.reservation}
          isOwner={isOwner}
          errors={this.state.errors}
          delegate={this} />
      </tr>
    );
  }

  changeBillingPeriod(name, value, dryrun) {
    var reservation = this.state.reservation;

    var year = parseInt(value.split('/')[0]);
    var month = parseInt(value.split('/')[1]) - 1;
    var day = parseInt(value.split('/')[2]);

    var billingPeriod = new Date(year, month, day, 0, 0);

    reservation.billing.period = billingPeriod;

    this.setState({
      reservation: reservation
    });

    this.updateResource([
      ['billing[period]', billingPeriod]
    ], true);

  }

  changeBillingPeriodDescription(name, value, dryrun) {
    var reservation = this.state.reservation;

    reservation.billing.period_description = value;

    this.setState({
      reservation: reservation
    });

    this.updateResource([
      ['billing[period_description]', value]
    ], true);
  }

  renderNote() {
    return (
      <tr>
        <th>メモ
          <span className="icon-form icon-form__optional dashboard-form-table__icon">
            任意
          </span>
        </th>
        <SMReservationEditViewNote
          note={this.state.reservation.note}
          errors={this.state.errors}
          delegate={this} />
      </tr>
    );
  }

  changeNote(name, value) {
    this.updateResource([
      [name, value]
    ], true);

    var reservation = this.state.reservation;
    reservation.note = value;
    this.setState({
      reservation: reservation
    });
  }

  renderChannelType() {
    var tableData;
    if (SMReservationHelper.isOwnerDirect(this.props.mediator)) {
      tableData =
        <SMOReservationEditViewChannelType
          reservation={this.state.reservation}
          channelTypes={this.state.channelTypes}
          delegate={this} />;

      return (
        <tr>
          <th>受付<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
          {tableData}
        </tr>
      );
    } else {
      return null;
    }
  }

  changeChannelType(name, value) {
    var reservation = this.state.reservation;
    reservation.channel_type = value;

    this.setState({
      reservation: reservation,
    });
  }

}

export default SMReservationEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditView.jsx